import { render, staticRenderFns } from "./BindGoodsDialog.vue?vue&type=template&id=ca8cb44e&scoped=true&lang=pug&"
import script from "./BindGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./BindGoodsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BindGoodsDialog.vue?vue&type=style&index=0&id=ca8cb44e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8cb44e",
  null
  
)

export default component.exports